export default {
  "title": "Profile",
  "description": "Manage account details and preferences.",
  "security": "Security",
  "notificationSettings": "Notification Settings",
  "notificationCenter": "Notification Center",
  "commandChannel": "Command Channel",
  "support": "Support",
  "sections": "Profile sections",
  "suspended": "Account Suspended",
  "suspendedDescription": "Your account has been suspended. Please contact your server administrator for more information.",
  "sessions": "Sessions",
  "sessionsDescription": "Review and manage active sessions.",
  "sessionsHint": "Track recent activity and sign out of other devices.",
  "hideSessions": "Hide sessions",
  "viewSessions": "View sessions",
  "sessionAlerts": "Session alerts",
  "alert": "Alert",
  "alertsFailed": "Unable to update session alerts",
  "tryAgain": "Please try again.",
  "alertsEnabled": "Session alerts enabled",
  "alertsDisabled": "Session alerts disabled",
  "appDashboard": "App Dashboard",
  "systemDashboard": "System Dashboard",
  "streamingDashboard": "Streaming Dashboard",
  "userAdmin": "User Admin",
  "userGroups": "User Groups",
  "userRoles": "User Roles",
  "settings": "Settings",
  "imageType": "Please upload a PNG, JPG, WEBP, or GIF file.",
  "uploadsDisabled": "Avatar uploads are disabled by your administrator.",
  "unsupportedFile": "Unsupported file",
  "fileTooLarge": "File too large",
  "avatarFailed": "Failed to upload avatar",
  "avatarUpdated": "Avatar updated",
  "bannerFailed": "Failed to upload banner",
  "bannerUpdated": "Banner updated",
  "securityToken": "Missing security token. Refresh the page.",
  "bannerRemoveFailed": "Failed to remove banner",
  "bannerRemoved": "Banner removed",
  "emailFailed": "Unable to update email.",
  "emailUpdated": "Email updated",
  "passwordFailed": "Unable to update password.",
  "passwordUpdated": "Password updated",
  "passwordChanged": "Your password was changed.",
  "editBanner": "Edit banner",
  "uploadBanner": "Upload banner",
  "picture": "Profile Picture",
  "pictureDescription": "Upload a custom avatar for your account.",
  "addBanner": "Add a profile banner",
  "dropZone": "Avatar upload drop zone",
  "avatarAlt": "Profile avatar",
  "chooseFile": "Choose file",
  "dropImage": "Drop image to crop",
  "cropAvatar": "Crop avatar",
  "uploading": "Uploading...",
  "saveUpload": "Save & upload",
  "banner": "Profile Banner",
  "bannerDescription": "Recommended 1500×500. Keep key details centered inside the safe area. Drag to reposition and use the slider to zoom.",
  "chooseBanner": "Choose banner",
  "removing": "Removing...",
  "removeBanner": "Remove banner",
  "account": "Account Information",
  "accountDescription": "Your core identity details.",
  "close": "Close",
  "edit": "Edit",
  "username": "Username",
  "defaultUser": "QuickBox User",
  "email": "Email",
  "role": "Role",
  "user": "User",
  "groups": "Groups",
  "noDescription": "No description provided.",
  "noGroups": "No groups assigned",
  "lastLogin": "Last login",
  "unknown": "Unknown",
  "editProfile": "Edit profile",
  "editDescription": "Changes take effect immediately. Your current session stays active.",
  "newEmail": "New Email",
  "saving": "Saving...",
  "saveEmail": "Save Email",
  "currentPassword": "Current Password",
  "newPassword": "New Password",
  "confirmPassword": "Confirm New Password",
  "savePassword": "Save Password",
  "cancel": "Cancel",
  "quickLinks": "Quick Links",
  "quickLinksDescription": "Jump back into your most used areas.",
  "imageSize": "Please upload an image under {{size}}.",
  "imageHint": "Drag & drop or choose a PNG, JPG, WEBP, or GIF (up to {{size}}).",
  "appAccess_one": "Access: {{formattedCount}} app",
  "appAccess_other": "Access: {{formattedCount}} apps",
  "emailRequired": "Email is required.",
  "emailInvalid": "Enter a valid email address.",
  "passwordRequired": "Fill out all password fields.",
  "passwordMismatch": "New passwords do not match.",
  "passwordLength": "Password must be at least 6 characters.",
  "passwordSuccess": "Password updated successfully.",
  "sessionsFailed": "Unable to load sessions.",
  "signInAgain": "Please sign in again.",
  "device": "Device",
  "userAgentUnknown": "Unknown user agent",
  "ip": "IP",
  "filterIPs": "Filter IPs",
  "authType": "Auth Type",
  "status": "Status",
  "ended": "Ended",
  "active": "Active",
  "current": "Current",
  "remembered": "Remembered",
  "endReason": "End Reason",
  "lastSeen": "Last seen",
  "lastSeenFilter": "Last Seen",
  "noSessions": "No active sessions found.",
  "password": "Password",
  "twoFactor": "2FA",
  "passkey": "Passkey",
  "loggedOut": "Logged out",
  "revoked": "Revoked",
  "expired": "Expired",
  "last24Hours": "Last 24 hours",
  "last7Days": "Last 7 days",
  "last30Days": "Last 30 days",
  "ipUnknown": "IP unknown",
  "appAccess_many": "Access: {{formattedCount}} apps"
} as const;
